import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_PROCESS_TEMPLATE_BY_ID = "GET_PROCESS_TEMPLATE_BY_ID";

export const service = async (data) => {
  const options: object = {
    url: `/Api/ProcessTemplate/GetProcessTemplateById?eaProcessTemplateId=` + data.eaProcessTemplateId,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_PROCESS_TEMPLATE_BY_ID, service, mock);
